(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-custom-header"]) return;
  try {
    
  class LmStickyHeader extends HTMLElement {
    constructor() {
      super();
      this.onScrollHandler = this.onScroll.bind(this);
      this.onMediaChange = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.section = this.closest('.section-lm-header');
      if (!this.section) return;

      this.stickyType = this.getAttribute('data-sticky-type') || 'on-scroll-up';
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerBounds = { top: 0, bottom: this.section.offsetHeight };
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();
      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.mediaQuery.addEventListener?.('change', this.onMediaChange);

      if (this.headerIsAlwaysSticky) {
        this.section.classList.add('shopify-section-header-sticky');
      }

      this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mediaQuery?.removeEventListener?.('change', this.onMediaChange);
      this.observer?.disconnect();
    }

    setHeaderHeight() {
      if (!this.section) return;
      document.documentElement.style.setProperty('--header-height', `${this.section.offsetHeight}px`);
    }

    createObserver() {
      this.observer?.disconnect();
      this.observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry) {
          const rect = entry.boundingClientRect;
          this.headerBounds = { top: rect.top + window.scrollY, bottom: rect.bottom + window.scrollY };
        }
        this.observer.disconnect();
      });
      this.observer.observe(this.section);
    }

    onScroll() {
      if (!this.section) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const threshold = Math.max(this.headerBounds.bottom, this.section.offsetHeight);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > threshold) this.section.classList.add('scrolled-past-header');
        else this.section.classList.remove('scrolled-past-header');
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > threshold) {
        this.section.classList.add('scrolled-past-header');
        requestAnimationFrame(() => this.hide());
      } else if (scrollTop < this.currentScrollTop && scrollTop > threshold) {
        this.section.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(() => this.reveal());
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = window.setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(() => this.hide());
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.section.classList.remove('scrolled-past-header');
        requestAnimationFrame(() => this.reset());
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.section.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.section.classList.add('shopify-section-header-sticky', 'animate');
      this.section.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.section.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.querySelectorAll('details[data-lm-menu][open]').forEach((detail) => detail.removeAttribute('open'));
    }

    closeSearchModal() {
      const searchModal = this.querySelector('details-modal');
      if (searchModal && typeof searchModal.close === 'function') searchModal.close(false);
    }
  }

  if (!customElements.get('lm-sticky-header')) {
    customElements.define('lm-sticky-header', LmStickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
